import {
  isLessThan72HoursToCollection,
  isMoreThan72HoursSinceCreation,
} from './helpers';
import {
  bookingWithNoInvite,
  hasDraftInvite,
  hasNoPendingInvite,
  isLastBookingInviteDraft,
  bookingHasReschedules,
} from '../../../common/garageHelpers';
import { sortBookingsByCollectionDateAscending } from '../../../common/helpers';
import { applyUserSelectedFilters } from '../../../common/garageFilters';

export const filterDefaultRelevantBookings = (bookings) =>
  bookings.filter((booking) => {
    if (isLessThan72HoursToCollection(booking)) {
      return true;
    }

    if (isMoreThan72HoursSinceCreation(booking)) {
      return true;
    }

    if (bookingWithNoInvite(booking)) {
      return true;
    }

    if (hasDraftInvite(booking)) {
      return true;
    }

    if (hasNoPendingInvite(booking)) {
      return true;
    }

    // eslint-disable-next-line no-console
    console.log('Hide Irrelevant Booking: ', {
      id: booking.bookingId,
      createdAt: booking.createdAt,
      collectionDateTimeLocal: booking.collectionDateTimeLocal,
      garageInvites: bookings.garageInvites,
    });
    return false;
  });

export const getBookingsForColumn = (bookings, columnType) => {
  let filteredBookings = bookings;

  if (columnType === 'manual') {
    filteredBookings = bookings.filter(
      (booking) => !isLastBookingInviteDraft(booking) && !bookingHasReschedules(booking)
    );
  }

  if (columnType === 'reschedule') {
    filteredBookings = bookings.filter(
      (booking) => !isLastBookingInviteDraft(booking) && bookingHasReschedules(booking)
    );
  }

  if (columnType === 'review') {
    filteredBookings = bookings.filter((booking) => isLastBookingInviteDraft(booking));
  }

  const sortedBookings = sortBookingsByCollectionDateAscending(filteredBookings);

  return sortedBookings.map((booking) => ({
    template: {},
    booking,
    drivers: [],
    id: `${booking.bookingId} `,
    draggable: false,
  }));
};

export const getColumnsWithBookings = (bookings = [], filters) => {
  const columnTitles = [
    {
      type: 'review',
      title: 'Review before auto-allocation',
    },
    {
      type: 'manual',
      title: 'Manual intervention required',
    },
    {
      type: 'reschedule',
      title: 'Garage wants to reschedule',
    },
  ];

  let filteredBookings = filterDefaultRelevantBookings(bookings);
  filteredBookings = applyUserSelectedFilters(filteredBookings, filters);

  return columnTitles.map((column) => {
    const cards = getBookingsForColumn(filteredBookings, column.type);

    return {
      id: column.type,
      title: column.title,
      label: cards.length.toString() || undefined,
      cards,
    };
  });
};
